<template>
  <div class="conditions">
    <div class="wraperRight" id="wraperRight" v-if="othersBaike.length > 0">
      <div class="maybeFollow">
        <div class="title mt110">你可能还关注：</div>
      </div>
      <div class="maybe-bk">
        <ul>
          <li v-for="(item, index) in othersBaike" :key="index">
            <a
              :href="item.url"
              :title="item.title"
              target="_blank"
              @click="countAd(4505)"
              ><img
                width="75"
                height="50"
                :alt="item.title"
                :src="item.photo || $baikeHeadDefaultImgUrl"
              /><span>{{ item.title }}</span></a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Conditions",
  props: {
    propsOtherBaike: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      othersBaike: [], //右侧豆腐块选车条件的可能关注
    };
  },
  watch: {
    propsOtherBaike(n) {
      this.othersBaike = n;
    },
  },
};
</script>

<style lang="scss" scoped>
.conditions {
  .maybeFollow {
    margin-bottom: 5px;
    .title {
      height: 27px;
      background: #f4f4f4;
      border-top: 1px solid #e0e0e0;
      line-height: 27px;
      color: #333333;
      font-weight: bold;
      padding-left: 10px;
    }
  }
  .maybe-bk {
    width: 310px;
    overflow: hidden;
    padding-top: 10px;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 103px;
        height: 100px;
        overflow: hidden;
        display: inline;
        margin-bottom: 18px;
        a {
          display: inline-block;
          width: 75px;
          color: #000;
          text-decoration: none;
          outline: none;
          img {
            border: 0;
            vertical-align: middle;
          }
        }
        span {
          color: #259;
          display: block;
          line-height: 23px;
          margin-top: 4px;
          cursor: pointer;
          &:hover {
            color: #ff6600;
          }
        }
      }
    }
  }
}
</style>